import React from 'react'

import classNames from 'classnames'

import { IconWrapper } from '../components'

export const IconThumbsDown = ({
  size,
  color,
  className,
  ...props
}: React.ComponentPropsWithoutRef<'svg'> & {
  size?: string | number
}) => (
  <IconWrapper {...props} className={classNames(className, "icon-centivo", "icon-centivo--thumbs-down")} iconColor={color} size={size} width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">

      <defs>
          <path d="M9,15.9999886 L4.35132373,15.9999359 C3.47119618,16.0099029 2.63109397,15.6328561 2.05353597,14.9686644 C1.47597797,14.3044727 1.2192397,13.4201529 1.35155225,12.548438 L2.73130431,3.5500639 C2.95561258,2.07094973 4.23537419,0.983152355 5.72,0.999806967 L17,0.999806967 C17.5522847,0.999806967 18,1.44771525 18,2 L18,13 C18,13.1399183 17.9706378,13.2782795 17.9138115,13.4061385 L13.9138115,22.4061385 C13.7533102,22.7672665 13.3951887,23 13,23 C10.790861,23 9,21.209139 9,19 L9,15.9999886 Z M5.70869569,2.99987127 C5.21005232,2.99429892 4.78346511,3.35689805 4.70844775,3.85156199 L3.32867627,12.8500641 C3.28464826,13.1401365 3.37022768,13.4349097 3.56274701,13.6563069 C3.75526634,13.8777042 4.03530042,14.0033864 4.34,14 L10,14 C10.5522847,14 11,14.4477153 11,15 L11,19 C11,19.892565 11.5846898,20.6485684 12.3919522,20.9058931 L16,12.7877855 L16,2.99987127 L5.70869569,2.99987127 Z M18,12.0000582 L19.6876825,12.0001563 C20.3326214,12.0115622 20.8866873,11.5524785 21,10.9232314 L21,4.07677109 C20.8866736,3.44752281 20.3321056,2.98844231 19.67,3 L18,3 L18,12.0000582 Z M17,1 L19.6523175,1.00015635 C21.3309455,0.970469428 22.7659324,2.20221784 22.9909755,3.86595721 L23,4 L23,11 L22.9909755,11.1340428 C22.7659324,12.7977822 21.3309455,14.0295306 19.67,14 L17,14 C16.4477153,14 16,13.5522847 16,13 L16,2 C16,1.44771525 16.4477153,1 17,1 Z" id="icon--centivo--thumbs-down"/>
      </defs>
      <g id="Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g transform="translate(-1466.000000, -1198.000000)"/>
          <g id="Icon/thumbs-down">
              <mask id="mask-2" fill="white">
                  <use xlinkHref="#icon--centivo--thumbs-down"/>
              </mask>
              <use id="Shape" fill="currentColor" xlinkHref="#icon--centivo--thumbs-down"/>
          </g>
      </g>
  </IconWrapper>
)
